// ============================================================================
// Moneda del sistema. El símbolo se configura en Admin → Configuración
// (cont_config.moneda) y se carga una vez al iniciar la app (AppContext).
// Todo el dinero se formatea con fmtMoneda → "B/. 1,000.00".
// ============================================================================
let _simbolo = 'B/.';

export function setMoneda(simbolo) {
  if (simbolo && String(simbolo).trim()) _simbolo = String(simbolo).trim();
}
export function getMoneda() { return _simbolo; }

// Formatea un número como dinero con el símbolo configurado: "B/. 1,000.00".
export function fmtMoneda(n) {
  return `${_simbolo} ${Number(n || 0).toLocaleString('es-PA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

// Monedas comunes para el selector de Admin.
export const MONEDAS = [
  { value: 'B/.', label: 'Balboa (B/.)' },
  { value: '$',   label: 'Dólar ($)' },
  { value: '€',   label: 'Euro (€)' },
  { value: '₡',   label: 'Colón (₡)' },
  { value: 'C$',  label: 'Córdoba (C$)' },
  { value: 'Q',   label: 'Quetzal (Q)' },
  { value: 'L',   label: 'Lempira (L)' },
];
